<template>
    <footer class="gFooter">Copyright &copy; {{ currentYear }} Prestact</footer>
</template>

<script>
    export default {
        data() {
            return {
                currentYear: new Date().getFullYear()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .gFooter {
        width: 100%;
        position: fixed;
        bottom: 0;
        padding: 1rem;
        text-align: center;
        color: rgb(255, 255, 255);
        z-index: $z-lvl4;
        background: #000;
    }
</style>


// WEBPACK FOOTER //
// src/layout/Footer.vue